/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Site add icon, found in empty state of Experience Monitoring.
 */
export const ICON_SITE_ADD = (
  <svg fill="none" height="176" viewBox="0 0 176 176" width="176" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 88C0 39.3989 39.3989 0 88 0C136.601 0 176 39.3989 176 88V144C176 161.673 161.673 176 144 176H88C39.3989 176 0 136.601 0 88Z"
      fill="#EDEDED"
    />
    <path
      d="M87.95 38C60.35 38 38 60.4 38 88C38 115.6 60.35 138 87.95 138C115.6 138 138 115.6 138 88C138 60.4 115.6 38 87.95 38ZM122.6 68H107.85C106.25 61.75 103.95 55.75 100.95 50.2C110.15 53.35 117.8 59.75 122.6 68ZM88 48.2C92.15 54.2 95.4 60.85 97.55 68H78.45C80.6 60.85 83.85 54.2 88 48.2ZM49.3 98C48.5 94.8 48 91.45 48 88C48 84.55 48.5 81.2 49.3 78H66.2C65.8 81.3 65.5 84.6 65.5 88C65.5 91.4 65.8 94.7 66.2 98H49.3ZM53.4 108H68.15C69.75 114.25 72.05 120.25 75.05 125.8C65.85 122.65 58.2 116.3 53.4 108ZM68.15 68H53.4C58.2 59.7 65.85 53.35 75.05 50.2C72.05 55.75 69.75 61.75 68.15 68ZM88 127.8C83.85 121.8 80.6 115.15 78.45 108H97.55C95.4 115.15 92.15 121.8 88 127.8ZM99.7 98H76.3C75.85 94.7 75.5 91.4 75.5 88C75.5 84.6 75.85 81.25 76.3 78H99.7C100.15 81.25 100.5 84.6 100.5 88C100.5 91.4 100.15 94.7 99.7 98ZM100.95 125.8C103.95 120.25 106.25 114.25 107.85 108H122.6C117.8 116.25 110.15 122.65 100.95 125.8ZM109.8 98C110.2 94.7 110.5 91.4 110.5 88C110.5 84.6 110.2 81.3 109.8 78H126.7C127.5 81.2 128 84.55 128 88C128 91.45 127.5 94.8 126.7 98H109.8Z"
      fill="#0774D2"
    />
    <circle cx="131" cy="131" fill="white" r="29" />
    <path
      clipRule="evenodd"
      d="M106.833 131C106.833 117.66 117.66 106.833 131 106.833C144.34 106.833 155.167 117.66 155.167 131C155.167 144.34 144.34 155.167 131 155.167C117.66 155.167 106.833 144.34 106.833 131ZM133.417 133.417H140.667C141.996 133.417 143.083 132.329 143.083 131C143.083 129.671 141.996 128.583 140.667 128.583H133.417V121.333C133.417 120.004 132.329 118.917 131 118.917C129.671 118.917 128.583 120.004 128.583 121.333V128.583H121.333C120.004 128.583 118.917 129.671 118.917 131C118.917 132.329 120.004 133.417 121.333 133.417H128.583V140.667C128.583 141.996 129.671 143.083 131 143.083C132.329 143.083 133.417 141.996 133.417 140.667V133.417Z"
      fill="#949494"
      fillRule="evenodd"
    />
  </svg>
);
